import { render, staticRenderFns } from "./LayerSwitch.vue?vue&type=template&id=ecce4926"
import script from "./LayerSwitch.vue?vue&type=script&lang=ts"
export * from "./LayerSwitch.vue?vue&type=script&lang=ts"
import style0 from "./LayerSwitch.vue?vue&type=style&index=0&id=ecce4926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports